import type { MaintenancePageReason } from '@r/lib/maintenance-error.ts';

/**
 * Bus léger pour afficher la page maintenance depuis du code non-React
 * (ex. chargement i18n, mutation login, intercepteur axios 503).
 *
 * L'écoute se fait dans {@link ServerErrorProvider}.
 */

type ServerErrorListener = (reason: MaintenancePageReason) => void;

const listeners = new Set<ServerErrorListener>();

/** Bascule l'app en mode page maintenance (remplace tout le contenu du provider). */
export function triggerServerError(reason: MaintenancePageReason = '500'): void {
  for (const listener of listeners) {
    listener(reason);
  }
}

/** S'abonne aux signaux maintenance ; retourne une fonction de désabonnement. */
export function subscribeToServerErrors(listener: ServerErrorListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
